
import Dent from "../../../assets/filled/Dent.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DentIcon({ className, dataTestid = "DentIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Dent data-testid={dataTestid} className={classes} {...rest} />
  );
}
